export enum AttendanceSheetStatusEnum {
  EM_PREENCHIMENTO = 1,
  AGUARDANDO_ASSINATURA = 2,
  AGUARDANDO_REVISAO = 3,
  CONCLUIDA = 4,
  EM_CORRECAO = 5,
}

/**
 * Returns the full, human-readable description for a given attendance sheet status.
 *
 * @param status - The status value from the {@link AttendanceSheetStatusEnum}.
 * @returns The full description of the status in Portuguese, or '-' if the status is unrecognized.
 */
export function attendanceSheetStatusEnumInFull(status?: AttendanceSheetStatusEnum): string {
  switch (status) {
    case AttendanceSheetStatusEnum.EM_PREENCHIMENTO:
      return 'Em preenchimento';
    case AttendanceSheetStatusEnum.AGUARDANDO_ASSINATURA:
      return 'Aguardando assinatura';
    case AttendanceSheetStatusEnum.AGUARDANDO_REVISAO:
      return 'Aguardando aprovação da subdefensoria';
    case AttendanceSheetStatusEnum.CONCLUIDA:
      return 'Concluída';
    case AttendanceSheetStatusEnum.EM_CORRECAO:
      return 'A Corrigir';
    default:
      return '-';
  }
}

export function getAttendanceSheetStatusEnumOptions(): {
  value: AttendanceSheetStatusEnum;
  label: string;
}[] {
  return Object.values(AttendanceSheetStatusEnum)
    .filter((v) => typeof v === 'number')
    .map((value) => ({
      value: value as AttendanceSheetStatusEnum,
      label: attendanceSheetStatusEnumInFull(
        value as AttendanceSheetStatusEnum,
      ),
    }));
}
